var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2vw",
    height: "2vw",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.488414,
    y: 0.488414,
    width: 35.0232,
    height: 35.0232,
    rx: 17.5116,
    fill: "#E77B7B",
    fillOpacity: 0.02
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.488414,
    y: 0.488414,
    width: 35.0232,
    height: 35.0232,
    rx: 17.5116,
    stroke: "#E77B7B",
    strokeWidth: 0.976827
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8058 15.4191L19.2348 17.9902L21.8695 20.6249L20.5203 21.974L17.8856 19.3393L15.3146 21.9104L14.0927 20.6885L16.6637 18.1175L14.0291 15.4828L15.3782 14.1336L18.0129 16.7683L20.5839 14.1973L21.8058 15.4191Z",
    fill: "#E77B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.c37ebb92cf6c114bf3e0f724ef416b71.svg";
export { ForwardRef as ReactComponent };